var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.784,
    height: 104.46,
    viewBox: "0 0 116.784 104.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9522",
    "data-name": "Grupo 9522",
    transform: "translate(-21.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9501",
    "data-name": "Grupo 9501",
    transform: "translate(21.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4060",
    "data-name": "Trazado 4060",
    d: "M811.231,444.047v.018h-11.7V403.774h8.008a6.817,6.817,0,0,0,6.818-6.818V376.944a6.8,6.8,0,0,0-6.108-6.749L774.67,403.779H791.7V444.07H721.95l0-40.277h-.383l33.685-33.681H744.673l-33.648,33.644h3.088v40.291h-11.82a3.921,3.921,0,1,0,0,7.842H811.231a3.921,3.921,0,1,0,0-7.842Z",
    transform: "translate(-698.37 -347.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4061",
    "data-name": "Trazado 4061",
    d: "M720.946,387.875v-2.522a10.464,10.464,0,1,0-7.837,0v2.522h-7.643a6.816,6.816,0,0,0-6.818,6.813v20.017a6.783,6.783,0,0,0,2.4,5.154l31.984-31.984Z",
    transform: "translate(-697.366 -365.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4062",
    "data-name": "Trazado 4062",
    d: "M720.9,421.542l33.671-33.671h1.83v-2.508a10.461,10.461,0,1,0-7.842,0v2.512h-4.573l-33.667,33.667Z",
    transform: "translate(-655.238 -365.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4063",
    "data-name": "Trazado 4063",
    d: "M716.3,403.778l33.667-33.667H739.381l-33.667,33.667Z",
    transform: "translate(-671.856 -347.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4064",
    "data-name": "Trazado 4064",
    d: "M716.745,370.111h0Z",
    transform: "translate(-670.44 -347.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4065",
    "data-name": "Trazado 4065",
    d: "M721.348,370.111h0Z",
    transform: "translate(-653.823 -347.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4066",
    "data-name": "Trazado 4066",
    d: "M725.951,370.111h0Z",
    transform: "translate(-637.205 -347.43)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.6a0bf81a59370ddd4939a5b6aa9ffba6.svg";
export { ForwardRef as ReactComponent };